define(function (require) {
  'use strict';
  var $ = require('jquery'),
    _ = require('underscore'),
    Alert = require('common/views/Alert'),
    Backbone = require('backbone'),
    EasyDialog = require('easyDialog'),

    html_template = require('common/templates/notifications/ConfirmClass.html'),
    template = _.template(html_template);

  return Backbone.View.extend({

    initialize: function () {
      if (this.options.notification) {
        // Came from notification.
        var notification = this.options.notification;

        this.scheduleId = notification.scheduleId;
        this.courseId = notification.courseId;
        this.notificationId = notification.id;
      } else if (this.options.liveclass) {
        // Came from live class

        this.scheduleId = this.options.liveclass.scheduleId;
        this.courseId = this.options.liveclass.courseId;
      }

      // We only need to act on this once
      Backbone.once('timer:confirm-times-up', this._confirmTimesUp);
    },

    onClose: function (event) {
      event.preventDefault();
      event.stopPropagation();

      $.easydialog.close('default');
    },

    render: function () {
      var data = this._prepareData();

      this.$el.html(template(data));

      return this;
    },

    show: function () {
      var me = this;

      me._confirmNotification();

      $.easydialog({
        content: $('#live-class-reminder'),
        closeOnEscape: false,
        onStart: function () {
          me.$popup = $('#live-class-reminder');

          me.$popup.find('.btn-confirm').on('click', function (event) {
            me._joinClass();
            me.onClose(event);
          });

          me.$popup.find('.btn-cancel').on('click', function (event) {
            me._cancelClass();
            me.onClose(event);
          });
        },
        onCleanup: function () {
          me.remove();
        }
      });
    },

    _confirmTimesUp: function () {
      $.easydialog.close('default');
      new Alert({title: i18n.liveReminder.timesUp.title, text: i18n.liveReminder.timesUp.text, container: 2});
    },

    _confirmNotification: function () {
      if (this.notificationId) {
        $.ajax({
          type: 'POST',
          url: '/notifications/confirm/' + this.notificationId,
          dataType: 'text',
          async: false,
          success: function () {
            this.notificationId = null;
          },
          error: function (jqXHR, textStatus, errorThrown) {
            // nothing better to do than nothing
          }
        });
      }
    },
//TODO Look at when this is getting called
    _joinClass: function () {
      var me = this,
        success = false;

      $.ajax({
        type: 'POST',
        url: '/liveclasses/requestliveclasses/' + this.scheduleId + '/' + this.courseId,
        dataType: 'text',
        contentType: 'application/json',
        async: false,
        success: function (data, textStatus, jqXHR) {
          Backbone.trigger('liveclass:joined', {scheduleId: me.scheduleId, courseId: me.courseId});
          success = true;
        },
        error: function (jqXHR, textStatus, errorThrown) {
          new Alert({title: i18n.alert.titleError, text: i18n.liveReminder.errors.joinError, container: 2});
        }
      });

      return success;
    },

    _cancelClass: function () {
      Backbone.trigger('liveclass:cancel');
    },

    _prepareData: function () {
      var data = {
        i18n: i18n,
        // Most of our messages for the confirm class dialog are reused from the
        // live reminder dialog, so we just use the live reminder's nls keys
        i18nPage: i18n.liveReminder
      };

      return data;
    }
  });
});



//////////////////
// WEBPACK FOOTER
// ./js/common/views/notifications/ConfirmClass.js
// module id = 1066
// module chunks = 26 27 28